import {
  ApplicationConfig,
  provideZoneChangeDetection,
  inject,
  LOCALE_ID,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  withXhr,
} from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { TokenRefreshService } from './core/services/auth/token-refresh.service';
import { provideScKit } from './ui';

// Register Spanish locale
registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // Kit propio (src/app/ui): las confirmaciones (askConfirm) se montan con el inyector de la app.
    provideScKit(),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    {
      provide: LOCALE_ID,
      useValue: 'es',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    // Monitoreo de la renovación del token desde el arranque.
    provideAppInitializer(() => inject(TokenRefreshService).startTokenRefreshMonitoring()),
  ],
};
